import { isEmpty } from 'lodash';
import React, { useContext } from 'react';
import AutoSuggestDropdown from './AutoSuggestDropdown';
import CollectionsSuggestion from './CollectionsSuggestion';
import { NullStateSuggestionTypes } from './Constants';
import useMedia from '../../Shared/utils/useMedia';
import SearchHistory from './SearchHistory';
import { SearchBarVariant } from '../NavSearchElements/searchUtils';
import { NavSearchContext } from '../NavSearchContext';
const searchBarVariantStyle = {
    [SearchBarVariant.ProminentSearch]: 'flex flex-col py-4 px-6 space-y-7',
    [SearchBarVariant.ProminentSearchHistoryExperiment]: 'flex flex-col py-4 px-6 space-y-7',
};
const NullSearchDropdown = ({ showSuggestions = false, suggestions = {
    latestCollections: [],
    trendingCollections: [],
}, autoSuggestDropdownProps = {}, latestCollectionsSuggestionProps = {}, trendingCollectionsSuggestionProps = {}, useNewSearchUI, contentType, }) => {
    var _a;
    const context = useContext(NavSearchContext);
    const { searchBarVariant } = context;
    const isLargeScreen = useMedia('(min-width: 1024px)', true);
    const numberItemsToShow = useNewSearchUI && !isLargeScreen ? 2 : 3;
    return (<AutoSuggestDropdown show={showSuggestions} className={(_a = searchBarVariantStyle[searchBarVariant]) !== null && _a !== void 0 ? _a : 'flex flex-col py-4 px-6 space-y-7 mt-2.5 -ml-2.5'} {...autoSuggestDropdownProps} useNewSearchUI={useNewSearchUI}>
      <SearchHistory contentType={contentType}>
        <>
          {!isEmpty(suggestions === null || suggestions === void 0 ? void 0 : suggestions.latestCollections) && (<CollectionsSuggestion collections={suggestions.latestCollections} title="Latest Collections" numberItemsToShow={numberItemsToShow} showSeeMoreLink={false} className="p-0" titleClassName="w-1/2" getTelemetryString={(routeUri) => `typeahead.null.collectionNew.${routeUri}`} idLabel={`${NullStateSuggestionTypes.latestCollections}`} {...latestCollectionsSuggestionProps}/>)}
          {!isEmpty(suggestions === null || suggestions === void 0 ? void 0 : suggestions.trendingCollections) && (<CollectionsSuggestion collections={suggestions.trendingCollections} title="Trending Collections" numberItemsToShow={numberItemsToShow} className="p-0 space-y-3" titleClassName="w-1/2" getTelemetryString={(routeUri) => `typeahead.null.collectionTrending.${routeUri}`} idLabel={`${NullStateSuggestionTypes.trendingCollections}`} {...trendingCollectionsSuggestionProps}/>)}
        </>
      </SearchHistory>
    </AutoSuggestDropdown>);
};
export default NullSearchDropdown;
